<main class="flex flex-col bg-app-bg h-dvh w-dvw text-white">
  <router-outlet></router-outlet>
</main>

@if(alert$ | async; as alert) {
  <app-alert-popup
    [alert]="alert"
    class="block absolute bottom-0 left-0 right-0 mb-8 z-30 w-11/12 mx-auto"></app-alert-popup>
}

@if(loading()) {
  <app-loading-overlay class="block fixed top-0 bottom-0 right-0 left-0 z-99999"></app-loading-overlay>
}
